import { defaultLocale } from "./default";
export const enUS = {
    ...defaultLocale,
    name: "enUS",
};
//# sourceMappingURL=en-us.js.map